<template>
  <div>
    <div class="mb-4">
      <strong class="mb-3 d-block">Email Content</strong>
      <div v-html="str_InnerHTML" contenteditable="false" class="mb-3"></div>
      <K2Input class="mb-3" name="emailSubject" @onchange="handleParentChange" placeholder="Email Subject"></K2Input>
      <K2Input class="mb-2" name="emailFrom" @onchange="handleParentChange" placeholder="Email From"></K2Input>
      <K2Text className="small" :style="{ color: uiVariable.color.error }">eg. @etonhouse.com.sg/ @etonhouse.edu.sg/ @middleton.edu.sg </K2Text>

      <K2Input name="emailToBcc" @onchange="handleParentChange" class="mb-2" placeholder="Additional Email to BCC"></K2Input>
      <K2Text className="small" :style="{ color: uiVariable.color.error }">eg. ABC1@gmail.com, ABC2@gmail.com </K2Text>
    </div>
    <div>
      <strong class="mb-3 d-block border-bottom pb-3">Email Setting</strong>
      <K2Row space-between="true" class="border-bottom pb-3 mb-3">
        <div>
          <K2Text bold="true" :color="uiVariable.color.secondary" class-name="me-2">Email Group</K2Text>
          <K2Text link="true" @onclick="handleSelectAll">Select All</K2Text>
        </div>
        <div>
          <K2Checkbox :list="emailGroupsData" @onchange="setSelectedGroup" :selected="emailGroups" isGroup="true" />

          <!-- <th v-for="eGroup in emailGroupsData">
                        <td><input type='checkbox' v-bind:value='eGroup' v-model='emailGroups' @onchange='setSelectedGroup()'>{{ eGroup.name }}</td>
                    </th> -->
        </div>
      </K2Row>
      <!--      <K2Row space-between="true" class="border-bottom pb-3">-->
      <!--        <K2Text bold="true" :color="uiVariable.color.secondary" class-name="me-2">Select Receiver Type</K2Text>-->
      <!--        <K2Row>-->
      <!--          <K2ToolTip content="Select by Student">-->
      <!--            <K2Image class="me-2 iconImage" :class="modalType==='student'&&'active'" :src="assets.icon.student" height="20"-->
      <!--                     link="true" @onclick="handleStudentClick()"/>-->
      <!--          </K2ToolTip>-->
      <!--          <K2ToolTip content="Select by Academic Year">-->
      <!--            <K2Image class="iconImage" :src="assets.icon.editSvg" :class="modalType==='academic'&&'active'" height="20" link="true"-->
      <!--                     @onclick="handleAcademicClick()"/>-->
      <!--          </K2ToolTip>-->
      <!--        </K2Row>-->
      <!--      </K2Row>-->
    </div>

    <div>
      <!--<tags-component @tags="setTags" :parent_Post="post" name="emailStudentListTags"></tags-component>-->
      <K2SelectStudent @tags="setTags" />
    </div>
  </div>
</template>

<script>
import K2Input from '../../../uiComponents/k2Input/k2Input'
import K2Text from '../../../uiComponents/k2Text/k2Text'
import uiVariable from '../../../config/uiVariable'
import K2Row from '../../../uiComponents/k2Row/k2Row'
import K2Checkbox from '../../../uiComponents/k2Checkbox/k2Checkbox'
import assets from '../../../assets/assets'
import tagsComponent from '../../../components/Post_Tags_Component'
import K2SelectStudent from '../../../uiComponents/k2SelectStudent/k2SelectStudentJapan'

export default {
  name: 'EmailPost',
  components: { K2SelectStudent, K2Checkbox, K2Row, K2Text, K2Input, tagsComponent },
  props: ['onchange', 'onchange_emailGroups', 'setModal', 'handleReceiverType', 'modalType', 'images', 'post', 'notifChange', 'paramInnerHTML'],
  data() {
    return {
      uiVariable: uiVariable,
      assets: assets,
      selectedGroup: [],
      selectAll: false,
      tags: [],
      str_InnerHTML: '',
      str_AddEmailtoBCC: '',
      isCheckAll: false,
      emailGroupsData: [
        { id: 'Father', name: 'Father' },
        { id: 'Mother', name: 'Mother' },
      ],
      emailGroups: [],
      selectedlang: '',
    }
  },
  mounted() {
    //console.log("exportHtmlContain") ;
    this.str_InnerHTML = this.paramInnerHTML
    // console.log('exportHtml:', this.str_InnerHTML);
  },
  watch: {
    paramInnerHTML: function (value) {
      this.str_InnerHTML = value
    },
  },
  methods: {
    handleParentChange(value, name) {
      this.$emit('onchange', value, name)
      // this[name] = value;
    },
    setSelectedGroup(value) {
      this.emailGroups = value

      this.isCheckAll = this.emailGroups.length === this.emailGroupsData.length
      this.$emit('onchange_emailGroups', this.emailGroups)
    },
    handleSelectAll() {
      this.isCheckAll = !this.isCheckAll
      this.emailGroups = []
      if (this.isCheckAll) {
        // Check all
        // for (const key in this.emailGroupsData) {
        //   this.emailGroups.push(this.emailGroupsData[key]);
        // }
        this.emailGroupsData.forEach(d => {
          this.emailGroups.push(d.name)
        })
      }
      this.$emit('onchange_emailGroups', this.emailGroups)
    },

    // handleStudentClick() {
    //   this.$emit("handleReceiverType", "student")
    // },
    // handleAcademicClick() {
    //   this.$emit("handleReceiverType", "academic")
    // },

    setTags(value) {
      let tagsList = []
      if (value?.length > 0) {
        value?.forEach(d => {
          tagsList.push(d.Student_ID)
        })
      }
      this.tags = tagsList
      // /this.$emit("result", this.tags); //Pass result object back to EmailExample.vue

      this.$emit('onchange', tagsList, 'emailStudentListTags') // Pass back to parent (Parent Function: onchange; PropertyName: emailStudentListTags)

      // if (this.tags.length > 0) {
      //   console.log("Tags Count:" + this.tags.length);
      // } else {
      //
      // }
    },
  },
}
</script>
